import React from "react";
import { Helmet } from "react-helmet";
import { useLocation } from "react-router-dom";

import { SITE_NAME, SITE_URL, DEFAULT_DESCRIPTION } from "../../data/content";

//Page title ("Title | Estia Venue & Events", as on the Wix site), description & canonical link.
//Social share (og:) tags are static in index.html - Facebook / WhatsApp don't run JavaScript, so they'd never see per-page ones
const PageMeta = ({ title, description = DEFAULT_DESCRIPTION, noIndex = false, isFullTitle = false }) => {
  const { pathname } = useLocation();
  const fullTitle = isFullTitle ? title : `${title} | ${SITE_NAME}`;
  const url = `${SITE_URL}${pathname === "/" ? "/" : pathname.replace(/\/+$/, "")}`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta
        name={"description"}
        content={description}
      />
      <link
        rel={"canonical"}
        href={url}
      />
      {noIndex ? (
        <meta
          name={"robots"}
          content={"noindex"}
        />
      ) : null}
    </Helmet>
  );
};

export default PageMeta;
